module.exports = __webpack_public_path__ + "assets/5c18182924e4da42f2ece274b315502e.mp3";